import {
  TableCells,
  TableColumn,
  TableFilterCells,
  useAutocompleteSource,
} from '@eas/common-web';
import { TechnicalObject } from '@models';
import { WorkOrderStateAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useTechnicalObjectTypes() {
  return useAutocompleteSource<WorkOrderStateAutocomplete>({
    url: `${EvidenceApiUrl.TECHNICAL_OBJECT_TYPES}/autocomplete`,
  });
}

export function useColumns(): TableColumn<TechnicalObject>[] {
  return [
    {
      datakey: 'fid',
      sortkey: 'fid',
      filterkey: 'fid',
      name: 'FID',
      width: 250,
      CellComponent: TableCells.TextCell,
      filterable: true,
      sortable: true,
    },
    {
      datakey: 'type.name',
      sortable: true,
      filterable: true,
      name: 'Typ',
      filterkey: 'type.id',
      width: 200,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterMultipleAutocompleteCellFactory(
          useTechnicalObjectTypes
        ),
    },
    {
      datakey: 'road',
      sortable: true,
      filterable: true,
      name: 'Cesta',
      filterkey: 'road',
      width: 200,
      CellComponent: TableCells.TextCell,
    },
  ];
}
